import React from "react";
import ServiceCard from "./ServiceCard";
import { serviceData } from "../../../data/serviceData";

const ServiceList = () => {
    return (
        <div className="service-list">

            {serviceData.map((service) => (
                <ServiceCard
                    key={service.id}
                    {...service}
                />
            ))}

        </div>
    );
};

export default ServiceList;